import api from 'api'

type AddCancellationPolicyWindow = {
  cutoffTime: number
  chargePercentage?: number
  chargeMinutes?: number
}

type AddCancellationPolicyRequest = {
  company_id: number
  startsAt: string | undefined
  policyWindows: AddCancellationPolicyWindow[]
}

export const addCancellationPolicy = async (
  request: AddCancellationPolicyRequest
): Promise<void> => {
  return api.post(`/admin/company/${request.company_id}/cancellation_policy`, {
    starts_at: request.startsAt,
    policy_windows: request.policyWindows.map((window) => ({
      cutoff_time: window.cutoffTime,
      ...(window.chargeMinutes != null
        ? { charge_minutes: window.chargeMinutes }
        : { charge_percentage: window.chargePercentage }),
    })),
  })
}
